/* eslint-disable */
import './modules/global';
import './modules/splide';
import {instant_defer} from "./modules/img-defer";
import {refreshCart} from "./modules/refreshCart";
import {AddToCart} from "./modules/cart";

window.addEventListener('load', () => {
    instant_defer();
    refreshCart('', {});
    new AddToCart();
})



// WEBPACK FOOTER //
// ./scripts/archive.js